<template>
  <div>
    <main class="bg-gray-100">
      <Title>{{ eventPage?.title }} - Buy Tickets</Title>
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-4">
        <div v-if="eventPage.details" class="my-4">
          <div>
            <h2 class="text-lg font-semibold">About {{ eventPage?.title }}</h2>
          </div>
          <div
            v-html="eventPage.details"
            class="bg-white rounded-md shadow-md my-4 p-4"
          />
        </div>
        <div v-if="!eventPage.details" class="mx-auto px-0 pb-8 mt-4">
          <h2 class="text-lg font-bold">Oops!</h2>
          <p>Event details not found.</p>
          <NuxtLink
            class="text-blue-700 hover:underline cursor-pointer font-semibold"
            :to="`/buy/tickets-${route?.params?.tenant}`"
          >
            Back to events
          </NuxtLink>
        </div>
      </div>
      <CartPoweredByWetixDivider v-if="route.query.embed" />

      <!-- Features Section -->
      <!-- <CartFeaturesRow v-if="eventPage && eventPage.cartTheme" /> -->
    </main>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from "~/stores/cart";
import { useEventPages } from "~/stores/eventpages";

// Page meta
definePageMeta({
  layout: "order",
});

const cart = useCartStore(); // Import cart Pinia store
const eventPage = useEventPages(); // Import eventPages Pinia store
// const tenantTheme = useTenantTheme() // Tenant Theme composable
const route = useRoute(); // Router
const config = useRuntimeConfig(); // Get runtime config
const $ga = useGoogleAnalytics(); // Google Analytics composable

// On page load here, reset the state until we debug cart cartRecovery
cart.$reset();

// Add tenant ID to analytics user properties
$ga.setUserProperties({
  tenantId: route?.params?.tenant,
});

// Fetch event page config from back-end (proxies to firestore) and set in store
try {
  eventPage.$patch({ isLoading: true });
  const { data: eventSpec } = (await useFetch(
    `${config.public.WETIX_SERVICE_API_BASE_URL}/v1/eventpages/${route.params.tenant}/${route.params.eventSlug}/details/`
  )) as any;
  eventPage.$patch({ ...eventSpec.value, isLoading: false });
  cart.$patch({
    depositSchemeSettings: eventSpec.value.depositSchemeSettings,
    depositSchemeEnabled: eventSpec.value.depositSchemeEnabled,
  });
} catch (error) {
  console.error(
    `Failed to fetch eventSpec for tenant ${route.params.tenant} and eventSlug ${route.params.eventSlug}`,
    error
  );
  console.error(error);
  eventPage.$patch({ isLoading: false, eventValid: false });
}
</script>

<style>
.ql-align-right {
  text-align: right;
}
.ql-align-left {
  text-align: left;
}
.ql-align-center {
  text-align: center;
}
.ql-align-justify {
  text-align: justify;
}
</style>
